@if (layer() === 'ruler') {
  @if (drag().mode === 'pin' || drag().mode === 'start') {
    <div
      data-testid="timeline-edit-marker"
      class="edit-marker"
      [style.left.px]="x()"
      [style.height]="'calc(' + height() + ' - 2rem)'"></div>
    <span class="edit-time-chip font-mono" [style.left.px]="x()">{{
      drag().time | date: 'HH:mm'
    }}</span>
  }
} @else if (drag().mode === 'move') {
  <div
    class="edit-carry is-free"
    [class.is-tour]="drag().carrying === 'tour'"
    [style.width.px]="width()">
    <span class="truncate">{{ drag().stopName }}</span>
  </div>

  <div class="edit-badge" aria-hidden="true">
    <i
      [class]="drag().carrying === 'tour' ? ICONS.stack : ICONS.arrowsOutCardinal"
      class="text-xs"></i>
    @if (drag().leaveBlocked) {
      <span>{{ 'features.plan.edit.move_drag.stays' | translate }}</span>
    } @else if (drag().target; as target) {
      @if (target.label === 'merge') {
        <span>{{ 'features.plan.edit.move_drag.merge_into' | translate }}</span>
        <span class="font-mono font-semibold">{{ target.stop?.name }}</span>
      } @else if (target.stop; as stop) {
        <span>{{ 'features.plan.edit.reorder_drag.move_before' | translate }}</span>
        <span class="font-mono font-semibold">{{ stop.name }}</span>
      } @else {
        <span>{{ 'features.plan.edit.reorder_drag.move_to_end' | translate }}</span>
      }
    } @else {
      <span>{{ 'features.plan.edit.move_drag.no_place' | translate }}</span>
    }
  </div>
} @else if (drag().mode === 'reorder') {
  <div class="edit-carry is-free" [style.width.px]="width()">
    <span class="truncate">{{ drag().stopName }}</span>
  </div>

  <div class="edit-badge" aria-hidden="true">
    <i [class]="ICONS.listNumber" class="text-xs"></i>
    @if (drag().target; as target) {
      @if (target.stop; as stop) {
        <span>{{ 'features.plan.edit.reorder_drag.move_before' | translate }}</span>
        <span class="font-mono font-semibold">{{ stop.name }}</span>
      } @else {
        <span>{{ 'features.plan.edit.reorder_drag.move_to_end' | translate }}</span>
      }
    } @else {
      <span>{{ 'features.plan.edit.reorder_drag.drop_in_gap' | translate }}</span>
    }
    <kbd class="key-chip is-pressed border-transparent">{{ altKey | translate }}</kbd>
  </div>
} @else if (drag().mode === 'start') {
  <!-- Drawn as the start marker is, so the drop lands where the ghost stood. -->
  <svg
    class="edit-start-ghost"
    viewBox="0 0 50 50"
    width="28"
    height="28"
    aria-hidden="true"
    [style.transform]="'translateX(' + (x() - 20) + 'px)'">
    <circle cx="25" cy="25" r="22" class="edit-start-ghost-ring" />
    <circle cx="25" cy="25" r="17" class="edit-start-ghost-disc" />
    <path
      d="M34.5 24.134C35.1667 24.5189 35.1667 25.4811 34.5 25.866L21 33.6603C20.3333 34.0452 19.5 33.564 19.5 32.7942V17.2058C19.5 16.436 20.3333 15.9548 21 16.3397L34.5 24.134Z"
      class="edit-start-ghost-glyph" />
  </svg>

  <span class="edit-shift font-mono" [style.left.px]="x() + 12">
    {{ 'features.plan.edit.pin_drag.shift' | translate: { shift: shift() } }}
  </span>

  <div class="edit-badge" aria-hidden="true">
    <i [class]="ICONS.play" class="text-xs"></i>
    <span>{{ 'features.plan.edit.start_drag.leaves_at' | translate }}</span>
    <span class="font-mono font-semibold">{{ drag().time | date: 'HH:mm' }}</span>
  </div>
} @else {
  @if (wallX() !== null) {
    <div data-testid="timeline-edit-wall" class="edit-wall" [style.left.px]="wallX()"></div>
    <span class="edit-wall-tag" [style.left.px]="wallX()">
      {{ 'features.plan.edit.pin_drag.earliest' | translate }}
      <span class="font-mono">{{ drag().earliest | date: 'HH:mm' }}</span>
    </span>
  }

  <div
    class="edit-carry"
    [style.transform]="'translateX(' + x() + 'px)'"
    [style.width.px]="width()">
    <span class="truncate">{{ drag().stopName }}</span>
  </div>

  <span class="edit-shift font-mono" [style.left.px]="x() + width() + 4">
    {{ 'features.plan.edit.pin_drag.shift' | translate: { shift: shift() } }}
  </span>

  <div class="edit-badge" aria-hidden="true">
    <i [class]="ICONS.pushPin" class="text-xs"></i>
    <span>{{ 'features.plan.edit.pin_drag.pin_at' | translate }}</span>
    <span class="font-mono font-semibold">{{ drag().time | date: 'HH:mm' }}</span>
    @if (atWall()) {
      <span class="opacity-70">{{
        'features.plan.edit.pin_drag.at_earliest' | translate
      }}</span>
    }
    <kbd class="key-chip border-transparent">{{ altKey | translate }}</kbd>
    <span class="opacity-70">{{ 'features.plan.edit.pin_drag.reorder' | translate }}</span>
  </div>
}
